import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useClientStore = defineStore('client', {
  state: () => ({
    clients: {},
    unsubs: []
  }),
  persist: { paths: ['clients'] },
  actions: {
    upsert({ id, value }) {
      this.clients = { ...this.clients, [id]: value };
    },
    remove(id) {
      const clients = { ...this.clients };
      delete clients[id];
      this.clients = clients;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.clients = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      let snapshotQuery = collection(firestore, 'clients');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('Client - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    }
  }
});
